import { userInfoStore } from '../../store/userInfoStore';
import { isTopC } from './skinHelper';
import { detectFloatNumPrecision } from './detectFloatNumPrecision';
/* eslint-disable no-unsafe-optional-chaining */

export const exchangeAmountByRate = ({ spinInfo, rate, currentUserId, precision, dataKey }) => {
  const amountPrecision = 10 ** +precision > 1 ? 10 ** +precision : 100;
  if (isTopC()) {
    return spinInfo[dataKey].toFixed(detectFloatNumPrecision(spinInfo[dataKey]));
  }
  let model;
  // eslint-disable-next-line
  if (
    +currentUserId === +spinInfo?.userId ||
    !spinInfo.userId ||
    spinInfo?.currencyCode === userInfoStore.currencyCodeAbbr
  ) {
    // eslint-disable-next-line
    model = {
      amount: Math.trunc(Math.round(spinInfo?.amount * amountPrecision)) / amountPrecision,
      winAmount: Math.trunc(Math.round(spinInfo?.winAmount * amountPrecision)) / amountPrecision,
    };
  } else {
    // eslint-disable-next-line
    model = {
      amount: Math.trunc((spinInfo?.coinAmount / +rate) * amountPrecision) / amountPrecision,
      winAmount: Math.trunc((spinInfo?.winCoinAmount / +rate) * amountPrecision) / amountPrecision,
    };
  }

  // TODO integrate Decimal JS
  return model[dataKey];
};

export const exchangeAmount = ({ betAmount, rate, precision }) => {
  const amountPrecision = 10 ** +precision > 1 ? 10 ** +precision : 100;
  return Math.trunc(betAmount * +rate * amountPrecision) / amountPrecision;
};
/* eslint-enable no-unsafe-optional-chaining */
